import { Component, ChangeDetectionStrategy, input, output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { StudentProfile } from '../../../api/models/student-profile';
import { InterestService } from '../../../shared/services/interest.service';

@Component({
  selector: 'app-student-sidebar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, FontAwesomeModule, NgbModule],
  template: `
    <!-- profile strength -->
    <div class="card mt-4">
      <div class="card-body">
        <h4 class="card-title">{{'Profile strength' | translate}}</h4>
        <ngb-progressbar class="mb-3" [showValue]="true" [value]="entity().profileStrength ?? 0"></ngb-progressbar>
        <ol class="list-group" *ngFor="let subject of remainingSubjects()">
          <li class="list-group-item cursor-pointer d-flex" *ngIf="!subject['validated']" (click)="goToSection.emit(subject['section'])">
            <span class="text flex-grow-1">{{subject.label | translate}}</span>
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </li>
        </ol>
      </div>
    </div>

    <!-- field of interest -->
    <div class="card mt-4">
      <div class="card-body">
        <h4 class="card-title">{{'Your field of interest' | translate}}</h4>
        <ul class="list-group" *ngIf="entity().areaOfInterests && entity().areaOfInterests?.length! > 0">
          <li *ngFor="let interest of entity().areaOfInterests; trackBy: trackById" class="list-group-item">
            {{interestService.getTranslatedName(interest)}}
          </li>
        </ul>
      </div>
    </div>
  `,
})
export class StudentSidebarComponent {
  readonly interestService = inject(InterestService);

  entity = input.required<StudentProfile>();
  remainingSubjects = input.required<any[]>();
  goToSection = output<string>();

  faChevronRight = faChevronRight;

  trackById = (_index: number, item: { id?: string | null }): string =>
    item.id ?? `index-${_index}`;
}
